/** Holiday closure of a website's shop. */
export default {
    index: {
        title: 'Holiday closure',
        intro: 'When {website} is shut for the holidays.',
        noWebsite: 'Select a website first to set its holiday closure.',
    },
    panel: {
        title: 'Holiday closure',
        intro: 'Days the shop is shut and nothing is packed or posted. {ordersKeepComing} the storefront shows a notice on the cart and the checkout saying which day the parcel ships, and every order taken during the closure is stamped with that date. Both days are included: shut 20 to 27 July means back on the 28th. Fill in both dates or neither.',
        ordersKeepComing: 'Orders keep coming in:',
        closedToday: 'Closed today. Orders placed now ship from {date}.',
        closing: 'Closing {from} to {until}, back on {resumes}.',
        firstDay: 'First day closed',
        lastDay: 'Last day closed',
        announceDays: 'Warn customers this many days ahead',
        announceHint: 'How long before the closure the notice appears. Two weeks suits a shop posting parcels; give a workshop building to order more. {zero} says nothing until the shop is actually shut.',
        ownWording: 'Your own wording',
        ownWordingHint: '(leave blank and we write the sentence for you)',
        defaultLocale: '(def)',
        messagePlaceholder: 'e.g. The workshop is shut for stocktaking.',
        clear: 'Clear the closure',
        save: 'Save holiday closure',
        saved: 'Holiday closure saved',
    },
};
